export const contentData = {
  spanish:{
    layout:{
      title:'Editar Correo',
      navigation:[
        {name:'Email',path:'/mails'},
        {name:'Editar',path:'/mails/:id/edit'},
        
      ],
      menu2:[
        {id:0, label:'Mis datos'},
        {id:1, label:'Horario'},
      ],
    },
  }
}